<template>
	<div :v-if="!!eventClass">
		<div v-if="eventID !== 'one-on-one'" :key="eventID">
			<About
				:eventName="eventClass.title"
				:about="eventClass.about"
				:images="eventClass.images"
				:classorevent="eventClass.type"
				:eventClass="eventClass"
			/>
			<Class
				:eventName="eventClass.title"
				:about="eventClass.about"
				:disableAt="6"
				:eventID="eventClass.id"
			/>
		</div>
		<div v-if="eventID === 'one-on-one'" :key="eventID">
			<OneOnOne :eventClass="eventClass" />
		</div>
	</div>
</template>

<script>
//import fb from '@/fb'
import Class from "../../components/Event-Class.vue";
import About from "../../components/AboutEvent-Class.vue";
import OneOnOne from "./OneOnOne.vue";
import _ from "lodash";
import { Events } from "../../Models/Events";

export default {
	components: {
		Class,
		About,
		OneOnOne,
	},
	props: {
		eventID: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			eventClass: {},
		};
	},
	methods: {},
	created() {
		const { eventID } = this.$props;

		this.eventClass = _.find(Events, (evt) => {
			return evt.id === eventID;
		});
	},
	updated() {
		const { eventID } = this.$props;

		this.eventClass = _.find(Events, (evt) => {
			return evt.id === eventID;
		});
	},
};
</script>
